import { motion } from "framer-motion";

export default function Marquee({
  items = ["Stay", "Relax", "Explore", "Sakleshpura", "Western Ghats", "Coffee Country", "Malnad"],
  invert = false,
}) {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className={`relative border-y overflow-hidden py-4 sm:py-6 ${
        invert
          ? "bg-[color:var(--ink)] text-[color:var(--paper)] border-[color:var(--line-inv)]"
          : "bg-[color:var(--paper)] text-[color:var(--ink)] border-[color:var(--line)]"
      }`}
    >
      <div className="marquee-track whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display text-[clamp(2.6rem,7vw,6rem)] tracking-tight leading-none inline-flex items-center gap-8"
          >
            <span>{t}</span>
            <span
              className={`inline-block h-3 w-3 rounded-full ${
                i % 2 ? "bg-[color:var(--clay)]" : "bg-[color:var(--sand)]"
              }`}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
